module.exports = __webpack_public_path__ + "static/media/girl-image-placeholder.ecb61bab.jpg";